"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.showErrorMessage = exports.showSuccessMessage = void 0;
var jquery_1 = __importDefault(require("jquery"));
function showMessage(message, type) {
    var $main = (0, jquery_1.default)('#main');
    if (!$main.length) {
        return;
    }
    var $flashMessages = (0, jquery_1.default)('.flash-message');
    $flashMessages.remove();
    var $flashMessage = (0, jquery_1.default)("<div class=\"flash-message\">\n<div class=\"row inner ".concat(type, "\">").concat(message, "</div>\n</div>"));
    $main.prepend($flashMessage);
    $flashMessage[0].scrollIntoView();
}
function showSuccessMessage(message) {
    showMessage(message, "success");
}
exports.showSuccessMessage = showSuccessMessage;
function showErrorMessage(message) {
    showMessage(message, "alert");
}
exports.showErrorMessage = showErrorMessage;
